export enum OrderPaymentTypeEnum {
  Cash = 1,
  NonCash,
}
